<template>

  <div class='chart-wrapper simpleLine'>

  </div>


</template>

<script>

	import * as d3 from 'd3';
	import simpleLine from "@/charts/simpleLine";

	export default {
		name: "SimpleLine",
    props: ["data", "color"],
    mounted() {
      new simpleLine({
        bindTo: d3.select(this.$el),
          color: this.color || "black",
          data: this.data,
      });
    }
	}
</script>

<style lang="less" scoped>

  .simpleLine {
    max-width: 300px;
    margin: 10px auto;
  }

</style>
